module.exports = __webpack_public_path__ + "img/interstellar-logistic-station.9d679c67.png";